module.exports = __webpack_public_path__ + "static/media/lumibeam-1.44e7b4eb.jpg";